import {createStyles} from '@mantine/core';
import classNames from 'classnames';
import React from 'react';

import {WHITE} from 'ui-library/Colors';

export interface SignupModalProps {
  children?: JSX.Element;
  wide?: boolean;
}

const useStyles = createStyles((theme, {wide}: {wide: boolean}) => ({
  page: {
    paddingLeft: wide ? theme.spacing.xxl : undefined,
    paddingRight: wide ? theme.spacing.xxl : undefined,
    paddingTop: '107px',
  },
  modal: {
    alignSelf: wide ? 'flex-start' : undefined,
    borderTop: wide ? `4px solid ${theme.colors.blue[6]}` : '7px solid #2A5CF9',
    borderRadius: wide ? '10px' : '0px 0px 4px 4px',
    boxShadow: wide ? '0px 1px 3px rgba(0, 0, 0, 0.08)' : '0px 2px 6px rgba(162, 185, 190, 0.7)',
    height: wide ? undefined : '476px',
    maxWidth: '100%',
    width: wide ? '1152px' : '775px',
    backgroundColor: WHITE,
  },
}));

function SignupModal(props: SignupModalProps): JSX.Element {
  const {classes} = useStyles({wide: props.wide ?? false});
  return <div className={classes.modal}>{props.children != null && props.children}</div>;
}

export interface SignupScreenProps {
  children?: JSX.Element;
  wide?: boolean;
}

export default function SignupScreen(props: SignupScreenProps): JSX.Element {
  // eslint-disable-next-line benchlint/no-multiple-use-styles -- pre-existing multiple createStyles hook calls in this file
  const {classes} = useStyles({wide: props.wide ?? false});
  return (
    <div
      className={classNames('u-flex-grow u-justify-content-center', {container: !props.wide}, classes.page)}
    >
      <SignupModal wide={props.wide}>{props.children}</SignupModal>
    </div>
  );
}
